
import { Component, OnInit } from '@angular/core';
import { LexTranslateService } from '@app/core/services/lex-translate.service';

@Component({
  selector: 'seb-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.css']
})
export class SuccessDialogComponent {

  constructor(public lextranslate: LexTranslateService) {}

}
